export default function IconBar() {
  return (
    <svg
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_bar_menu"
    >
      <g id="Icon">
        <path d="m3 6.5c0-.27614.22386-.5.5-.5h17c.2761 0 .5.22386.5.5s-.2239.5-.5.5h-17c-.27614 0-.5-.22386-.5-.5z"></path>
        <path d="m3 12c0-.2761.22386-.5.5-.5h17c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-17c-.27614 0-.5-.2239-.5-.5z"></path>
        <path d="m3.5 17.5c-.27614 0-.5.2239-.5.5s.22386.5.5.5h17c.2761 0 .5-.2239.5-.5s-.2239-.5-.5-.5z"></path>
      </g>
    </svg>
  );
}
